import React, { useState } from 'react';

import ModalSidebar, {
  ModalSidebarContent,
} from '../../../../components/ModalSidebar';
import {
  DocumentPreview,
  isPreviewableType,
} from '../../../../pages/Documents2/DocumentInfo/DocumentPreview';
import { Attachment } from '../types';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';
import Button from '../../../../../../components/button';
import FlairIcon from '../../../../../../atomic/atoms/FlairIcon';

type Props = {
  attachment: Attachment;
  onClose: () => void;
};

const i18Path = 'recruitment.candidate.info.attachments';

const AttachmentPreviewSidebar: React.FC<Props> = ({ attachment, onClose }) => {
  const t = useNamespacedTranslation(i18Path);
  const [isExpanded, setIsExpanded] = useState(false);

  const handleDownload = () => {
    if (attachment.downloadLink) {
      window.open(attachment.downloadLink);
    }
  };

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  const headerActions = (
    <span
      role="button"
      onClick={toggleExpanded}
      className="d-flex align-items-center">
      <FlairIcon
        icon={isExpanded ? 'compress-outline' : 'expand-outline'}
        size="sm"
        cursor="pointer"
        tooltip={isExpanded ? t('collapse') : t('expand')}
        tooltipPlacement="bottom"
      />
    </span>
  );

  const body = (
    <div className="position-relative h-100 w-100">
      {attachment.viewLink && isPreviewableType(attachment.fileType) ? (
        <DocumentPreview
          type={attachment.fileType}
          url={attachment.viewLink}
          width="100%"
        />
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center h-100">
          <p className="text-muted">{t('previewNotAvailable')}</p>
        </div>
      )}
    </div>
  );

  const footer = (
    <Button variant="primary" label={t('download')} onClick={handleDownload} />
  );

  return (
    <ModalSidebar
      show={true}
      onClose={onClose}
      header={attachment.name}
      size={isExpanded ? 'xxl' : 'xl'}
      headerActions={headerActions}
      content={<ModalSidebarContent body={body} footer={footer} />}
    />
  );
};

export default AttachmentPreviewSidebar;
